import getters from './getters';
import actions from './actions';

export default {
  actions,
  getters,
};
